module.exports = __webpack_public_path__ + "static/media/f2jtxt.135a8560.png";